import { env } from '$env/dynamic/public';

const BASE_URL = import.meta.env.SSR
	? env.PUBLIC_HOST_URL_SERVER_SIDE
	: env.PUBLIC_HOST_URL_CLIENT_SIDE;

const TEASER_BASE_URL = import.meta.env.SSR
	? env.PUBLIC_TEASER_HOST_URL_SERVER_SIDE
	: env.PUBLIC_HOST_URL_CLIENT_SIDE;


const LOGIN_URL = env.PUBLIC_LOGIN_URL || '';
const PUBLIC_UNSUPPORTED_BROWSER_URL = env.PUBLIC_UNSUPPORTED_BROWSER_URL || '';
const MEIN_UP_URL = env.PUBLIC_MEIN_UP_URL || '';
const SERVICE_UNAVAILABLE_URL = env.PUBLIC_HOST_SERVICE_UNAVAILABLE_URL || '';

const PUBLIC_ENV = env.PUBLIC_ENV;

const ORDER_DETAIL_PAGE_URL = env.PUBLIC_ORDER_DETAIL_PAGE;

export const environment = {
	BASE_URL,
	TEASER_BASE_URL,
	LOGIN_URL,
	SERVICE_UNAVAILABLE_URL,
	PUBLIC_ENV,
	MEIN_UP_URL,
	PUBLIC_UNSUPPORTED_BROWSER_URL,
	ORDER_DETAIL_PAGE_URL
};
